export default __webpack_public_path__ + "static/2-sexy-map-map-03b23978b2ccc9d74891943ff5683977.png";